import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GenerateAiEmailTemplate as GenerateAiEmailTemplateMutation,
    GenerateAiEmailTemplateVariables,
    AiEmailTemplateGenerateInput,
} from 'nutshell-graphql-types';

import GENERATE_AI_EMAIL_TEMPLATE from '../mutations/generate-ai-email-template.graphql';

export const useGenerateAiEmailTemplate = (): {
    generateAiEmailTemplate: (arg1: AiEmailTemplateGenerateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [generateAiEmailTemplate, {loading, error}] = useMutation<
        GenerateAiEmailTemplateMutation,
        GenerateAiEmailTemplateVariables
    >(GENERATE_AI_EMAIL_TEMPLATE);

    return {
        generateAiEmailTemplate: (input: AiEmailTemplateGenerateInput) =>
            generateAiEmailTemplate({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
